import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=95ca5502&scoped=true&"
import script from "./CommentThread.vue?vue&type=script&lang=js&"
export * from "./CommentThread.vue?vue&type=script&lang=js&"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=95ca5502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ca5502",
  null
  
)

export default component.exports